import { Order } from "../../../../store/types/common";

export const DEFAULT_PAGE_SIZE = 15;
export const DEFAULT_PATIENT_PAGE_SIZE = 100;
export const DEFAULT_SORTING_PATIENTS = "lastName";
export const DEFAULT_SORTING_USERS = "name";
export const DEFAULT_ORDER = Order.Asc;
